import React from "react"
import { Link } from "react-router-dom"
import { Button } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

export default function EditBookingButton({ bookingInfo }) {
  const { t } = useTranslation()
  return (
    <div>
      <Link to={`/reservation/edit/${bookingInfo?.id}`}>
        <Button size="sm" colorScheme="yellow">
          {t("general.edit")}
        </Button>
      </Link>
    </div>
  )
}
